<ng-container *ngIf="paginationButtonsArray$ | async as visiblePages">
  <nav aria-label="Pagination" i18n-aria-label>
    <ul class="pages">
      <li *ngIf="showSkipButtons$ | async">
        <button
          class="no-style-button page-indicator skip"
          [disabled]="disableBackButtons$ | async"
          aria-label="Skip to first page"
          i18n-aria-label
          (click)="skipToBeginning()">
          <img [src]="'assets/icons/grey/Double Chevron Left.svg'" alt="" aria-hidden="true" />
        </button>
      </li>
      <li>
        <button
          class="no-style-button page-indicator nav"
          [disabled]="disableBackButtons$ | async"
          aria-label="Go to previous page"
          i18n-aria-label
          (click)="previousPageClicked()">
          <img [src]="'assets/icons/grey/Chevron Left.svg'" alt="" aria-hidden="true" />
        </button>
      </li>
      <li class="pagination-element pt-2" *ngIf="showLeftEllipsis$ | async" aria-hidden="true">
        <img class="ellipsis" [src]="'assets/icons/dark/Ellipses-Horizontal.svg'" alt="" />
      </li>
      <li *ngFor="let page of visiblePages">
        <button
          class="no-style-button page-indicator"
          [class.active]="(currentPage$ | async) === page"
          [attr.aria-label]="'Go to page ' + page"
          (click)="pageClicked(page)">
          <div class="page-number">{{ page }}</div>
        </button>
      </li>
      <li class="pagination-element pt-2" *ngIf="showRightEllipsis$ | async" aria-hidden="true">
        <img class="ellipsis" [src]="'assets/icons/dark/Ellipses-Horizontal.svg'" alt="" />
      </li>
      <li>
        <button
          class="no-style-button page-indicator nav"
          [disabled]="disableForwardButtons$ | async"
          aria-label="Go to next page"
          i18n-aria-label
          (click)="nextPageClicked()">
          <img [src]="'assets/icons/grey/Chevron Right.svg'" alt="" aria-hidden="true" />
        </button>
      </li>

      <li *ngIf="showSkipButtons$ | async">
        <button
          class="no-style-button page-indicator skip"
          [disabled]="disableForwardButtons$ | async"
          aria-label="Skip to last page"
          i18n-aria-label
          (click)="skipToEnd()">
          <img [src]="'assets/icons/grey/Double Chevron Right.svg'" alt="" aria-hidden="true" />
        </button>
      </li>
    </ul>
  </nav>
</ng-container>
